module.exports = __webpack_public_path__ + "static/media/iconFive.366ae80f.svg";